/**
 * @generated SignedSource<<d77d46f7bf58f15c7db5b8bc5fdff0a7>>
 * @relayHash 40b8d8023e11e578e794058494ddf74b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 614d704f3cf3a78d6f89b60f3736ea0423ba4917e7ebbcd840cd6fe8c916635b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type JiraProjectOptions = {
  projectType?: JiraProjectType | null | undefined;
};
export type getProjectPropsQuery$variables = {
  cloudId: string;
  projectOptions?: JiraProjectOptions | null | undefined;
};
export type getProjectPropsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly recentlyUsedProjects: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
            readonly project: {
              readonly avatar: {
                readonly small: string | null | undefined;
              } | null | undefined;
            };
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type getProjectPropsQuery = {
  response: getProjectPropsQuery$data;
  variables: getProjectPropsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectOptions"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "projectOptions",
    "variableName": "projectOptions"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v5 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getProjectPropsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "concreteType": "JiraJqlProjectFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "recentlyUsedProjects",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraJqlProjectFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraJqlProjectFieldValue",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v4/*: any*/),
                            {
                              "concreteType": "JiraProject",
                              "kind": "LinkedField",
                              "name": "project",
                              "plural": false,
                              "selections": [
                                (v5/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getProjectPropsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraJqlProjectFieldValueConnection",
                "kind": "LinkedField",
                "name": "recentlyUsedProjects",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraJqlProjectFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraJqlProjectFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "614d704f3cf3a78d6f89b60f3736ea0423ba4917e7ebbcd840cd6fe8c916635b",
    "metadata": {},
    "name": "getProjectPropsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fd56c3329d89c9b7b3643e5023702d4a";

export default node;
